import $ from 'jquery';
import Toast from '../../../components/toasts';
import { ToastType } from '../../../types/toast';
export default class GiftCartValidation {
    static init() {
        if ($('.js__submit-prize-form').length) {
            this.isPrizeValid();
        }
    }
    static isPrizeValid() {
        $('.js__submit-prize-form').on('click', e => {
            const $target = $(e.currentTarget);
            $.get($target.data('check-prize'), res => {
                if (!res.errors.length) {
                    if ($target.data('next-step')) {
                        window.location.replace($target.data('next-step'));
                    }
                    else {
                        $('.js__prize-checkout-form').submit();
                    }
                }
                else {
                    res.errors.forEach((value) => Toast.callToast(ToastType.Error, value, $target.data('error-title')));
                }
            });
        });
    }
}
